import {
  drawPointsAnim,
  drawAngleAnim,
  drawLineAnim,
  drawCircleAnim,
  rotateCircleAnim,
  addCustomDelay,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    AngleManager,
    cCoord,
  } = context;

  const centerPoint = PointManager.getPoints()[0];
  const intersecPoint = PointManager.intersecPoint;
  const centerPointCoord = PointManager.getPointsCoord()[0];
  const pointsCoord = PointManager.getRedPointsCoord();
  const tangentCoords = PointManager.getTangentCoords(false);
  const RedPoints = PointManager.getRedPoints();
  const interSecCoord = PointManager.getIntersecCoord();

  const initialRadian = PointManager.getInitialRadians();
  const angles = AngleManager.getAngles();

  PointManager.setIntersecPointVisible(false);
  AngleManager.draw(pointsCoord, interSecCoord, false);
  circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);

  drawPointsAnim([centerPoint]);
  await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);

  await drawLineAnim(LineManager.lines[0], centerPointCoord, pointsCoord[0]);
  await drawLineAnim(LineManager.lines[1], centerPointCoord, pointsCoord[1]);

  intersecPoint.draw(interSecCoord)
  drawPointsAnim([intersecPoint]);

  await drawLineAnim(LineManager.lines[2], interSecCoord, tangentCoords[0]);
  await drawLineAnim(LineManager.lines[3], interSecCoord, tangentCoords[1]);

  LineManager.lines[2].draw(interSecCoord, pointsCoord[0]);
  LineManager.lines[3].draw(interSecCoord, pointsCoord[1]);
  LineManager.lines[4].draw(interSecCoord, tangentCoords[0]);
  LineManager.lines[5].draw(interSecCoord, tangentCoords[1]);
  await addCustomDelay(100);

  LineManager.lines[2].setVisibleOfEqualSymbol(true);
  LineManager.lines[3].setVisibleOfEqualSymbol(true);
	await addCustomDelay(500);

  drawAngleAnim(angles[0], "x");
  await drawAngleAnim(angles[1], "x");

  await rotateCircleAnim((v) => {
    const arr = Array(2).fill(v).map((v, vI) => ({ pTag: RedPoints[vI].tag, radian: normalizeRadian(initialRadian[vI] + v) }));
    PointManager.setRadian(arr)
  });

  await drawPointsAnim(RedPoints);
  onComp();
}